export default __webpack_public_path__ + "static/media/shovelIcon.c48d5ba5.png";